import { configureStore } from "@reduxjs/toolkit";
import MainSlice from "./store/Main/store";
import MyProductIncomeSlice from "./store/myProductIncome/store";
import ProjectInspireTargetDetailSlice from "./store/projectInspireTargetDetail/store";
import AppSettingSlice from "./utils/appStore";

const store = configureStore({
  reducer: {
    MainSlice,
    MyProductIncomeSlice,
    ProjectInspireTargetDetailSlice,
    AppSettingSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
